import request from "../utils/request";

export async function createFolder(folder) {
    return request.post("document/folder", folder);
}

export async function updateFolder(folder) {
    return request.put("document/folder", folder);
}

export async function getFolders() {
    return request.get("document/folder");
}

export async function getFolderWithFiles(id) {
    return request.get(`document/folder-with-files/${id}`);
}

export async function addFile(documentFileAddDto) {
    console.log(documentFileAddDto);
    return request.post("document/file", documentFileAddDto, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export async function deleteFile(id) {
    return request.delete(`document/file/${id}`);
}

export async function getFileBranches(id) {
    return request.get(`document/file-branches/${id}`);
}

export async function addBranchesToFile(addBranchesToFileDto) {
    return request.post("document/add-branches-to-file", addBranchesToFileDto);
}

export async function deleteFolder(id) {
    return request.delete(`document/folder/${id}`);
}

export async function updateFile(file) {
    return request.put("document/file", file);
}